<mat-checkbox
  [formControl]="formControl"
  [id]="id"
  [formlyAttributes]="field"
  [tabIndex]="props.tabindex"
  [indeterminate]="props.indeterminate && formControl.value === null"
  [color]="props.color"
  [labelPosition]="props.labelPosition || 'after'"
>
  <span
    *ngIf="props.htmlLabel; else defaultLabel"
    [innerHTML]="props.htmlLabel"
  >
  </span>
  <ng-template #defaultLabel>{{ props.label }}</ng-template>
  <span
    *ngIf="props.required && props.hideRequiredMarker !== true"
    aria-hidden="true"
    class="mat-form-field-required-marker"
    >*</span
  >
</mat-checkbox>
<div class="checkbox-error-wrapper">
  <mat-error *ngIf="formControl.touched && formControl.invalid" @slideInTop>
    <formly-validation-message [field]="field"></formly-validation-message>
  </mat-error>
</div>
